/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OrganizationRouteImport } from './routes/organization'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrganizationIndexRouteImport } from './routes/organization/index'
import { Route as OrganizationSlugRouteImport } from './routes/organization/$slug'
import { Route as OrganizationSlugIndexRouteImport } from './routes/organization/$slug/index'
import { Route as OrganizationSlugRecruitmentRouteImport } from './routes/organization/$slug/recruitment'
import { Route as OrganizationSlugOverviewRouteImport } from './routes/organization/$slug/overview'
import { Route as OrganizationSlugMembersRouteImport } from './routes/organization/$slug/members'
import { Route as OrganizationSlugExpensesRouteImport } from './routes/organization/$slug/expenses'
import { Route as OrganizationSlugEventsRouteImport } from './routes/organization/$slug/events'
import { Route as OrganizationSlugAutomationsRouteImport } from './routes/organization/$slug/automations'

const OrganizationRoute = OrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationIndexRoute = OrganizationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrganizationRoute,
} as any)
const OrganizationSlugRoute = OrganizationSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => OrganizationRoute,
} as any)
const OrganizationSlugIndexRoute = OrganizationSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrganizationSlugRoute,
} as any)
const OrganizationSlugRecruitmentRoute =
  OrganizationSlugRecruitmentRouteImport.update({
    id: '/recruitment',
    path: '/recruitment',
    getParentRoute: () => OrganizationSlugRoute,
  } as any)
const OrganizationSlugOverviewRoute =
  OrganizationSlugOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => OrganizationSlugRoute,
  } as any)
const OrganizationSlugMembersRoute = OrganizationSlugMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => OrganizationSlugRoute,
} as any)
const OrganizationSlugExpensesRoute =
  OrganizationSlugExpensesRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => OrganizationSlugRoute,
  } as any)
const OrganizationSlugEventsRoute = OrganizationSlugEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => OrganizationSlugRoute,
} as any)
const OrganizationSlugAutomationsRoute =
  OrganizationSlugAutomationsRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => OrganizationSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/invite': typeof InviteRoute
  '/organization': typeof OrganizationRouteWithChildren
  '/organization/$slug': typeof OrganizationSlugRouteWithChildren
  '/organization/': typeof OrganizationIndexRoute
  '/organization/$slug/automations': typeof OrganizationSlugAutomationsRoute
  '/organization/$slug/events': typeof OrganizationSlugEventsRoute
  '/organization/$slug/expenses': typeof OrganizationSlugExpensesRoute
  '/organization/$slug/members': typeof OrganizationSlugMembersRoute
  '/organization/$slug/overview': typeof OrganizationSlugOverviewRoute
  '/organization/$slug/recruitment': typeof OrganizationSlugRecruitmentRoute
  '/organization/$slug/': typeof OrganizationSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/invite': typeof InviteRoute
  '/organization': typeof OrganizationIndexRoute
  '/organization/$slug/automations': typeof OrganizationSlugAutomationsRoute
  '/organization/$slug/events': typeof OrganizationSlugEventsRoute
  '/organization/$slug/expenses': typeof OrganizationSlugExpensesRoute
  '/organization/$slug/members': typeof OrganizationSlugMembersRoute
  '/organization/$slug/overview': typeof OrganizationSlugOverviewRoute
  '/organization/$slug/recruitment': typeof OrganizationSlugRecruitmentRoute
  '/organization/$slug': typeof OrganizationSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/invite': typeof InviteRoute
  '/organization': typeof OrganizationRouteWithChildren
  '/organization/$slug': typeof OrganizationSlugRouteWithChildren
  '/organization/': typeof OrganizationIndexRoute
  '/organization/$slug/automations': typeof OrganizationSlugAutomationsRoute
  '/organization/$slug/events': typeof OrganizationSlugEventsRoute
  '/organization/$slug/expenses': typeof OrganizationSlugExpensesRoute
  '/organization/$slug/members': typeof OrganizationSlugMembersRoute
  '/organization/$slug/overview': typeof OrganizationSlugOverviewRoute
  '/organization/$slug/recruitment': typeof OrganizationSlugRecruitmentRoute
  '/organization/$slug/': typeof OrganizationSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/invite'
    | '/organization'
    | '/organization/$slug'
    | '/organization/'
    | '/organization/$slug/automations'
    | '/organization/$slug/events'
    | '/organization/$slug/expenses'
    | '/organization/$slug/members'
    | '/organization/$slug/overview'
    | '/organization/$slug/recruitment'
    | '/organization/$slug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/invite'
    | '/organization'
    | '/organization/$slug/automations'
    | '/organization/$slug/events'
    | '/organization/$slug/expenses'
    | '/organization/$slug/members'
    | '/organization/$slug/overview'
    | '/organization/$slug/recruitment'
    | '/organization/$slug'
  id:
    | '__root__'
    | '/'
    | '/invite'
    | '/organization'
    | '/organization/$slug'
    | '/organization/'
    | '/organization/$slug/automations'
    | '/organization/$slug/events'
    | '/organization/$slug/expenses'
    | '/organization/$slug/members'
    | '/organization/$slug/overview'
    | '/organization/$slug/recruitment'
    | '/organization/$slug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InviteRoute: typeof InviteRoute
  OrganizationRoute: typeof OrganizationRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/organization': {
      id: '/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof OrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization/': {
      id: '/organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof OrganizationIndexRouteImport
      parentRoute: typeof OrganizationRoute
    }
    '/organization/$slug': {
      id: '/organization/$slug'
      path: '/$slug'
      fullPath: '/organization/$slug'
      preLoaderRoute: typeof OrganizationSlugRouteImport
      parentRoute: typeof OrganizationRoute
    }
    '/organization/$slug/': {
      id: '/organization/$slug/'
      path: '/'
      fullPath: '/organization/$slug/'
      preLoaderRoute: typeof OrganizationSlugIndexRouteImport
      parentRoute: typeof OrganizationSlugRoute
    }
    '/organization/$slug/recruitment': {
      id: '/organization/$slug/recruitment'
      path: '/recruitment'
      fullPath: '/organization/$slug/recruitment'
      preLoaderRoute: typeof OrganizationSlugRecruitmentRouteImport
      parentRoute: typeof OrganizationSlugRoute
    }
    '/organization/$slug/overview': {
      id: '/organization/$slug/overview'
      path: '/overview'
      fullPath: '/organization/$slug/overview'
      preLoaderRoute: typeof OrganizationSlugOverviewRouteImport
      parentRoute: typeof OrganizationSlugRoute
    }
    '/organization/$slug/members': {
      id: '/organization/$slug/members'
      path: '/members'
      fullPath: '/organization/$slug/members'
      preLoaderRoute: typeof OrganizationSlugMembersRouteImport
      parentRoute: typeof OrganizationSlugRoute
    }
    '/organization/$slug/expenses': {
      id: '/organization/$slug/expenses'
      path: '/expenses'
      fullPath: '/organization/$slug/expenses'
      preLoaderRoute: typeof OrganizationSlugExpensesRouteImport
      parentRoute: typeof OrganizationSlugRoute
    }
    '/organization/$slug/events': {
      id: '/organization/$slug/events'
      path: '/events'
      fullPath: '/organization/$slug/events'
      preLoaderRoute: typeof OrganizationSlugEventsRouteImport
      parentRoute: typeof OrganizationSlugRoute
    }
    '/organization/$slug/automations': {
      id: '/organization/$slug/automations'
      path: '/automations'
      fullPath: '/organization/$slug/automations'
      preLoaderRoute: typeof OrganizationSlugAutomationsRouteImport
      parentRoute: typeof OrganizationSlugRoute
    }
  }
}

interface OrganizationSlugRouteChildren {
  OrganizationSlugAutomationsRoute: typeof OrganizationSlugAutomationsRoute
  OrganizationSlugEventsRoute: typeof OrganizationSlugEventsRoute
  OrganizationSlugExpensesRoute: typeof OrganizationSlugExpensesRoute
  OrganizationSlugMembersRoute: typeof OrganizationSlugMembersRoute
  OrganizationSlugOverviewRoute: typeof OrganizationSlugOverviewRoute
  OrganizationSlugRecruitmentRoute: typeof OrganizationSlugRecruitmentRoute
  OrganizationSlugIndexRoute: typeof OrganizationSlugIndexRoute
}

const OrganizationSlugRouteChildren: OrganizationSlugRouteChildren = {
  OrganizationSlugAutomationsRoute: OrganizationSlugAutomationsRoute,
  OrganizationSlugEventsRoute: OrganizationSlugEventsRoute,
  OrganizationSlugExpensesRoute: OrganizationSlugExpensesRoute,
  OrganizationSlugMembersRoute: OrganizationSlugMembersRoute,
  OrganizationSlugOverviewRoute: OrganizationSlugOverviewRoute,
  OrganizationSlugRecruitmentRoute: OrganizationSlugRecruitmentRoute,
  OrganizationSlugIndexRoute: OrganizationSlugIndexRoute,
}

const OrganizationSlugRouteWithChildren =
  OrganizationSlugRoute._addFileChildren(OrganizationSlugRouteChildren)

interface OrganizationRouteChildren {
  OrganizationSlugRoute: typeof OrganizationSlugRouteWithChildren
  OrganizationIndexRoute: typeof OrganizationIndexRoute
}

const OrganizationRouteChildren: OrganizationRouteChildren = {
  OrganizationSlugRoute: OrganizationSlugRouteWithChildren,
  OrganizationIndexRoute: OrganizationIndexRoute,
}

const OrganizationRouteWithChildren = OrganizationRoute._addFileChildren(
  OrganizationRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InviteRoute: InviteRoute,
  OrganizationRoute: OrganizationRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
